import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../services/administrator/admin.service';
import { MaterialModule } from '../../../shared/module/material.module';
import { SharedServices } from '../../../shared/services/shared.services';
 
@Component({
  selector: 'app-usd-conversion-rate',
  imports: [FormsModule, CommonModule, MaterialModule],
  templateUrl: './usd-conversion-rate.component.html',
  styleUrls: ['./usd-conversion-rate.component.css'],
})
 
export class UsdConversionRateComponent implements OnInit {
  usdRate: number | null = null;
  initialUsdRate: number | null = null;
  showMessage: boolean = false;
  showError: boolean = false;
  isLoading: boolean = false;
  noChangesMessage: boolean = false;
 
  constructor(private adminService: AdminService, private sharedService: SharedServices) {}
 
  ngOnInit(): void {
    this.loadUsdRate();
  }
 
  loadUsdRate(): void {
    this.adminService.loadUsdRate().subscribe({
      next: rate => {
        this.usdRate = rate.usdRate1;
        this.initialUsdRate = rate.usdRate1;
      },
      error: err => {
        this.showError = true;
      }
    });
  }
 
  saveUsdRate(): void {
    this.showError = false;
    this.showMessage = false;
    this.isLoading = true;
    this.noChangesMessage = false;
 
    if (this.usdRate === null || this.usdRate === undefined || this.usdRate.toString().trim() === '') {
      this.showError = true;
      this.isLoading = false;
      this.sharedService.openModal('Message', 'USD rate is required');
      return;
    }
 
    const usdRatePattern = /^[0-9]*\.?[0-9]+$/;
    if (!usdRatePattern.test(this.usdRate.toString())) {
      this.showError = true;
      this.isLoading = false;
      this.sharedService.openModal('Message', 'Please enter a valid number');
      return;
    }
 
    if (this.usdRate === this.initialUsdRate) {
      this.noChangesMessage = true;
      this.isLoading = false;
      this.sharedService.openModal('Message', 'No changes made to the USD rate.');
      return;
    }
 
    this.adminService.saveUsdRate(this.usdRate).subscribe({
      next: () => {
        this.isLoading = false;
        this.showMessage = true;
        this.initialUsdRate = this.usdRate;
        this.sharedService.openModal('Message', 'USD rate updated successfully');
      },
      error: err => {
        this.showError = true;
        this.isLoading = false;
        this.sharedService.openModal('Message', 'Error updating USD rate');
      }
    });
  }
 
  resetForm(): void {
    this.isLoading = true;
    this.adminService.loadUsdRate().subscribe({
      next: rate => {
        this.usdRate = rate.usdRate1;
        this.initialUsdRate = rate.usdRate1;
        this.isLoading = false;
        this.showMessage = false;
        this.showError = false;
        this.noChangesMessage = false;
      },
      error: err => {
        this.showError = true;
        this.isLoading = false;
      }
    });
  }
 
}